
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './public/page-not-found/page-not-found.component';
import { AppRoutes } from './app.routes';
import { AdminComponent } from './admin/admin.component';
import { PublicComponent } from './public/public.component';
import { AuthComponent } from './auth/auth.component';
import { authGuard } from './_core/guard/auth.guard';


const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' }, // Redirect root to auth
  { path: 'auth', component: AuthComponent, loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  {
    path: AppRoutes.Admin,
    component: AdminComponent,
    canActivate: [authGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'public',
    component: PublicComponent,
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'forms/:publicUrl',
    title: 'Form',
    loadComponent: () => import('./public/public-form/public-form.component').then(m => m.PublicFormComponent)
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, {
    // enableTracing: true, //uncomment for debugging only}
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'top',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


